// Contact page at `/contact`. Structure from Figma Make's ContactPage:
// message form (2/3) + three small contact-method cards (1/3).
//
// TODO: form is stateful-only; wire to a POST endpoint + optionally
// react-hook-form + zod once the backend action exists.

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  H1,
  Input,
  Label,
  P,
  Textarea,
} from '@podium/platform/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

export const Route = createFileRoute('/contact')({
  component: ContactPage,
})

const CONTACT_METHODS = [
  {
    title: 'E-mail',
    value: 'office@godishni-otcheti.com',
    href: 'mailto:office@godishni-otcheti.com',
  },
  {
    title: 'Телефон',
    value: '+359 2 XXX XXXX',
    href: 'tel:+35929999999',
  },
  { title: 'Адрес', value: 'София, България', href: null },
] as const

function ContactPage() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  })

  const setField =
    (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setForm({ ...form, [k]: e.target.value })

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // TODO: POST to /api/contact once the endpoint exists.
    console.log('contact submission', form)
  }

  return (
    <div className="mx-auto max-w-6xl px-6 py-8">
      <div className="mb-6 space-y-2">
        <H1>Свържете се с нас</H1>
        <P className="text-muted-foreground">
          Имате въпрос по процедурата, плащането или издадена фактура? Отговаряме в рамките на 24
          часа в работни дни.
        </P>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>Изпратете съобщение</CardTitle>
          </CardHeader>
          <CardContent>
            <form className="space-y-4" onSubmit={onSubmit}>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="space-y-2">
                  <Label htmlFor="name">Име</Label>
                  <Input
                    id="name"
                    name="name"
                    required
                    value={form.name}
                    onChange={setField('name')}
                    placeholder="Вашето име"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">E-mail</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    required
                    value={form.email}
                    onChange={setField('email')}
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="subject">Тема</Label>
                <Input
                  id="subject"
                  name="subject"
                  required
                  value={form.subject}
                  onChange={setField('subject')}
                  placeholder="Относно..."
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="message">Съобщение</Label>
                <Textarea
                  id="message"
                  name="message"
                  rows={8}
                  required
                  value={form.message}
                  onChange={setField('message')}
                  placeholder="Вашето съобщение..."
                />
              </div>

              <Button type="submit">Изпрати съобщение</Button>
            </form>
          </CardContent>
        </Card>

        <div className="space-y-4">
          {CONTACT_METHODS.map(({ title, value, href }) => (
            <Card key={title}>
              <CardHeader className="pb-2">
                <CardTitle className="text-base">{title}</CardTitle>
              </CardHeader>
              <CardContent>
                {href ? (
                  <a href={href} className="text-sm">
                    {value}
                  </a>
                ) : (
                  <P className="text-sm">{value}</P>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      <P className="mt-6 text-xs text-muted-foreground">
        Личните данни се обработват съгласно <a href="/privacy">Политиката за поверителност</a> и се
        използват само за отговор на Вашето запитване.
      </P>
    </div>
  )
}
